import React from 'react';
import Link from 'next/link';
import { useTranslations } from '../../../locales/useTranslations';

const ZeroTrustVpnPricing = () => {
  const { t } = useTranslations();

  return (
    <section className="ms-section ms-section--alt">
      <div className="container">
        <div className="ms-pricing-box">
          <h3>{t('managedServices_zeroTrustVpn_pricing_title')}</h3>
          <p>{t('managedServices_zeroTrustVpn_pricing_text')}</p>
          <Link href="/kontakt/" className="ms-header__btn-primary">
            {t('managedServices_zeroTrustVpn_pricing_cta')}
          </Link>
        </div>
      </div>
    </section>
  );
};

export default ZeroTrustVpnPricing;
